<template>
    <div class="leadership_wrapper">
        <div class="container">
            <div class="leadership">
                <div class="leadership_inner text_center">
                    <div v-if="users.length" class="container">
                        <div class="nav_category">
                            <div class="categories_inner text_center">
                                <div class="category_link second_font active">
                                    <div class="link_title">
                                        {{ group.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex people_container">
                        <single-leader
                            v-for="(person, index) of users"
                            :key="person.fullName + index"
                            :person="person"
                            @contact-us="onContactUs"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseGroup from '@/components/about/BaseGroup';
import SingleLeader from '@/components/about/SingleLeader';

export default {
    components: {
        SingleLeader
    },

    extends: BaseGroup
};
</script>
